import React from 'react';

import { DEFAULT_END_DATE, DEFAULT_START_DATE } from 'src/constants/dashboard';
import { useDashboardCVAdminData, useDashboardUsageReports } from 'src/hooks/dashboard';

import { MIN_DATE, NOW } from '../constants';
import { DashboardUsageReportsBlock } from '../DashboardUsageReportsBlock';

export const DashboardGlobalCVAdminUsageReportsBlock: React.FC = () => {
  const {
    peos,
    employers,
    usageReportStartDate,
    usageReportEndDate,
    setUsageReportStartDate,
    setUsageReportEndDate,
  } = useDashboardCVAdminData();

  const { dashboardUsageReportsItems, isDashboardUsageReportsLoading } = useDashboardUsageReports({
    variables: {
      peoIds: peos?.map(peo => peo.id),
      employerIds: employers?.map(employer => employer.id),
      from: (usageReportStartDate || DEFAULT_START_DATE).toISO(),
      to: (usageReportEndDate || DEFAULT_END_DATE).toISO(),
    },
  });

  return (
    <DashboardUsageReportsBlock
      dashboardUsageReportsItems={dashboardUsageReportsItems}
      minDate={MIN_DATE}
      maxDate={NOW}
      loading={isDashboardUsageReportsLoading}
      startDate={usageReportStartDate}
      endDate={usageReportEndDate}
      onStartDateChange={setUsageReportStartDate}
      onEndDateChange={setUsageReportEndDate}
    />
  );
};
